"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeoMatrix = getKeoMatrix;
exports.firstEightRowsHeader = firstEightRowsHeader;
exports.addMatrixHeaders = addMatrixHeaders;
exports.insertNoDataMessage = insertNoDataMessage;
exports.insertMatrixData = insertMatrixData;
var headers_1 = require("../headers");
var keo_card_1 = require("./keo_card");
var common_1 = require("../common");
var headers = headers_1.KEO_ANNUAL_HEADERS;
var sheetHeaders = headers_1.SHEET_EIGHT_HEADERS;
/**
 * Pobiera dane KEO i mapuje je na listę ReportKeoData
    * @param EupType - Typ EUP
 * @param Year - Rok
 * @returns Lista ReportKeoData
 */
function getKeoMatrix(EupType, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var keoList, uniqueWasteCodes, limitedWasteCodes, matrix;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, keo_card_1.getKeoDataAndMappingToList)(EupType.clientId, EupType.clientSecret, EupType.eupId, Year)];
                case 1:
                    keoList = _a.sent();
                    uniqueWasteCodes = new Set();
                    keoList.forEach(function (item) {
                        if (item.wasteCode && !uniqueWasteCodes.has(item.wasteCode)) {
                            uniqueWasteCodes.add(item.wasteCode);
                        }
                    });
                    limitedWasteCodes = (0, common_1.limitTrialData)(Array.from(uniqueWasteCodes), EupType.isTrial);
                    matrix = [
                        headers
                    ];
                    // Mapowanie na macierz
                    matrix.push.apply(matrix, limitedWasteCodes.map(function (wasteCode) {
                        var item = keoList.find(function (i) { return i.wasteCode === wasteCode; });
                        return [
                            wasteCode || "",
                            item ? item.wasteCodeDescription || "" : "",
                            item ? item.cardNumber || "" : "",
                            item ? (item.wasteMassInstallation || 0) : 0,
                            item ? (item.wasteMassExcludingInstallation || 0) : 0,
                            item ? (item.treatedWasteMass || 0) : 0,
                            item ? (item.forwardedWasteMass || 0) : 0
                        ];
                    }));
                    //Dodanie do wasteCode sumy wszytkich wartości wasteMassInstallation z elemetntów item..KeoGenerated.items keoList do wasteMassInstallation dla danego wasteCode w matrix
                    matrix.forEach(function (row, index) {
                        if (index > 0) { // Pomijamy nagłówek
                            var wasteCode_1 = row[0];
                            var totalInstallation = keoList
                                .filter(function (card) { return card.wasteCode === wasteCode_1 && card.Generated && Array.isArray(card.Generated.items); })
                                .flatMap(function (card) { return card.Generated.items; })
                                .reduce(function (sum, item) { var _a; return sum + ((_a = item.wasteMassInstallation) !== null && _a !== void 0 ? _a : 0); }, 0);
                            row[3] = totalInstallation; // Ustawiamy sumę w kolumnie wasteMassInstallation
                            var totalExcludingInstallation = keoList
                                .filter(function (card) { return card.wasteCode === wasteCode_1 && card.Generated && Array.isArray(card.Generated.items); })
                                .flatMap(function (card) { return card.Generated.items; })
                                .reduce(function (sum, item) { var _a; return sum + ((_a = item.wasteMassExcludingInstallation) !== null && _a !== void 0 ? _a : 0); }, 0);
                            row[4] = totalExcludingInstallation; // Ustawiamy sumę w kolumnie wasteMassExcludingInstallation
                            var totalTreated = keoList
                                .filter(function (card) { return card.wasteCode === wasteCode_1 && card.Treated && Array.isArray(card.Treated.items); })
                                .flatMap(function (card) { return card.Treated.items; })
                                .reduce(function (sum, item) { var _a; return sum + ((_a = item.treatedWasteMass) !== null && _a !== void 0 ? _a : 0); }, 0);
                            row[5] = totalTreated; // Ustawiamy sumę w kolumnie treatedWasteMass
                            var totalForwarded = keoList
                                .filter(function (card) { return card.wasteCode === wasteCode_1 && card.Forwarded && Array.isArray(card.Forwarded.items); })
                                .flatMap(function (card) { return card.Forwarded.items; })
                                .reduce(function (sum, item) { var _a; return sum + ((_a = item.wasteMass) !== null && _a !== void 0 ? _a : 0); }, 0);
                            row[6] = totalForwarded; // Ustawiamy sumę w kolumnie forwardedWasteMass
                        }
                    });
                    return [2 /*return*/, matrix];
            }
        });
    });
}
/**
 * Metoda tworzy nagłówek arkusza - pierwsze 8 wierszy oraz formaruje szerokości kolum dla danych
 * @param sheetName - nazwa arkusza
 * @param EupType - Typ EUP
 * @param year - rok zestawienia
 * @param dateTo - data końcowa
 */
function firstEightRowsHeader(sheetName, EupType, year) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, ReportId, headerTitleRange, headerValueRange, currentdate, formattedDate;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    ReportId = "CW03";
                                    // Ustawienie koloru tła dla całego arkusza
                                    sheet.getRange("A1:G8").format.fill.color = "#E7E7E7";
                                    // Wysokości pierwszych 8 wierszy
                                    sheet.getRange("1:1").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("2:2").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("3:3").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("4:4").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("5:5").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("6:6").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("7:7").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("8:8").format.rowHeight = common_1.firstSevenRowsLastRowHeight;
                                    //await context.sync();
                                    // Formatowanie kolumn
                                    sheet.getRange("A:A").format.columnWidth = 255;
                                    sheet.getRange("B:B").format.columnWidth = 360;
                                    sheet.getRange("C:C").format.columnWidth = 205;
                                    sheet.getRange("D:D").format.columnWidth = 205;
                                    sheet.getRange("E:E").format.columnWidth = 205;
                                    sheet.getRange("F:F").format.columnWidth = 205;
                                    sheet.getRange("G:G").format.columnWidth = 205;
                                    headerTitleRange = sheet.getRange("A1:A7");
                                    headerTitleRange.format.fill.color = "#688BBB";
                                    headerTitleRange.format.font.bold = true;
                                    headerTitleRange.format.font.color = "#FFFFFF";
                                    headerTitleRange.format.font.size = common_1.firstSevenRowsFontSize;
                                    headerTitleRange.format.verticalAlignment = "Center";
                                    sheet.getRange("A1").values = [[sheetHeaders.REPORT_TITLE]];
                                    sheet.getRange("A1").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A1").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A2").values = [[sheetHeaders.DESCRIPTION]];
                                    sheet.getRange("A2").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A2").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A3").values = [[sheetHeaders.BDOENTITY]];
                                    sheet.getRange("A3").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A3").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A4").values = [[sheetHeaders.MPD]];
                                    sheet.getRange("A4").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A4").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A5").values = [[sheetHeaders.MPD_NUMBER]];
                                    sheet.getRange("A5").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A5").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A6").values = [[sheetHeaders.REPORT_YEAR]];
                                    sheet.getRange("A6").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A6").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A7").values = [[sheetHeaders.DATA_IMPORT]];
                                    sheet.getRange("A7").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A7").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    headerValueRange = sheet.getRange("B1:C7");
                                    headerValueRange.format.fill.color = "#F7F7F7";
                                    headerValueRange.format.font.color = "#000000";
                                    headerValueRange.format.font.size = common_1.firstSevenRowsFontSize;
                                    headerValueRange.format.verticalAlignment = "Center";
                                    sheet.getRange("B1").values = [["".concat(ReportId, " - KEO ROCZNE")]];
                                    sheet.getRange("B1").format.font.bold = true;
                                    sheet.getRange("B1").format.font.color = "#688BBB";
                                    sheet.getRange("B1:C1").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B1:C1").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B2").values = [["Podsumowanie kart ewidencji odpadów dla danego roku"]];
                                    sheet.getRange("B2:C2").merge();
                                    sheet.getRange("B2:C2").format.wrapText = true;
                                    sheet.getRange("B2:C2").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B2:C2").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B3").values = [[EupType.bdoentityname || "Brak danych"]];
                                    sheet.getRange("B3:C3").merge();
                                    sheet.getRange("B3:C3").format.wrapText = true;
                                    sheet.getRange("B3:C3").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B3:C3").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B4").values = [[EupType.name]];
                                    sheet.getRange("B4:C4").merge();
                                    sheet.getRange("B4:C4").format.wrapText = true;
                                    sheet.getRange("B4:C4").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B4:C4").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B5:C5").numberFormat = [["@"]]; // Format tekstowy ustawiony PRZED wstawieniem wartości
                                    sheet.getRange("B5").values = [[EupType.identificationNumber]];
                                    sheet.getRange("B5:C5").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B5:C5").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B6").values = [[year]];
                                    sheet.getRange("B6").format.horizontalAlignment = "Left";
                                    sheet.getRange("B6:C6").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B6:C6").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    currentdate = new Date();
                                    formattedDate = currentdate.toLocaleDateString("pl-PL", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit"
                                    });
                                    sheet.getRange("B7").values = [[formattedDate]];
                                    sheet.getRange("B7").format.horizontalAlignment = "Left";
                                    sheet.getRange("B7:C7").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B7:C7").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    // Aktywuj arkusz
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda dodaje nagłówki kolumn dla danych z Matrix
 * @param sheetName - arkusz do wstawienia nagłówka
 */
function addMatrixHeaders(sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, headerTitleRange, columns;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    sheet.getRange("9:9").format.rowHeight = common_1.matrixHeadersDefaultRowHeight;
                                    headerTitleRange = sheet.getRange("A9:G9");
                                    headerTitleRange.format.fill.color = "#404040";
                                    headerTitleRange.format.font.bold = true;
                                    headerTitleRange.format.font.color = "#FFFFFF";
                                    headerTitleRange.format.font.size = common_1.matrixHeadersDefaultFontSize;
                                    headerTitleRange.format.verticalAlignment = "Center";
                                    headerTitleRange.format.horizontalAlignment = "Center";
                                    headerTitleRange.format.wrapText = true;
                                    headerTitleRange.values = [headers];
                                    columns = ["A8", "B8", "C8", "D8", "E8", "F8", "G8"];
                                    columns.forEach(function (cellAddress) {
                                        sheet.getRange(cellAddress).format.borders.getItem("EdgeLeft").color = "#E8E8E8";
                                        sheet.getRange(cellAddress).format.borders.getItem("EdgeLeft").weight = Excel.BorderWeight.thin;
                                    });
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda wstawia informacj o braku danych do raportu dla zadanego okresu i dla wybranego MPD
 * @param sheetName - nazwa arkusza
 * @param EupType - Typ EUP
 */
function insertNoDataMessage(sheetName, EupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, noDataMessageRange, columns, rows;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    noDataMessageRange = sheet.getRange("A10:G12");
                                    noDataMessageRange.format.rowHeight = 30;
                                    noDataMessageRange.format.fill.color = "#F6F6F6";
                                    noDataMessageRange.format.font.size = 12;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    columns = ["A", "B", "C", "D", "E", "F", "G"];
                                    rows = [10, 11, 12];
                                    rows.forEach(function (row) {
                                        columns.forEach(function (col) {
                                            var cellAddress = "".concat(col).concat(row);
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                        });
                                    });
                                    sheet.getRange("A11").values = [["Brak danych do raportu dla zadanego okresu i dla wybranego MPD"]];
                                    sheet.getRange("A11").format.font.color = "#F10606";
                                    sheet.getRange("A11").format.font.size = 14;
                                    //sheet.getRange("A10").format.horizontalAlignment = "Center";
                                    sheet.getRange("A11").format.verticalAlignment = "Center";
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    _a.sent();
                                    if (!EupType.isTrial) return [3 /*break*/, 4];
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A14:G14", EupType.isTrial)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: 
                                // Dodanie Copyright 
                                return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A15:G15")];
                                case 5:
                                    // Dodanie Copyright 
                                    _a.sent();
                                    //Aktywowana komórka A10
                                    sheet.getRange("A11").select();
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda dodaje dane z Matrix do arkusza
 * @param sheetName - nazwa arkusza
 * @param matrix - macierz danych do wstawienia
 * @param EupType - Typ EUP
 */
function insertMatrixData(sheetName, matrix, EupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, dataMatrix, firstDataRow, rowRange, range, dataRowsCount, _loop_1, i, textFormatColumns, trialRow, copyrightRow;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    dataMatrix = matrix.slice(1);
                                    firstDataRow = 10;
                                    rowRange = 9 + dataMatrix.length;
                                    range = sheet.getRange("A10:G" + rowRange);
                                    range.values = dataMatrix;
                                    dataRowsCount = dataMatrix.length;
                                    _loop_1 = function (i) {
                                        var rowIndex = i + firstDataRow;
                                        var rowRange_1 = sheet.getRange("A".concat(rowIndex, ":G").concat(rowIndex));
                                        // Wysokość wiersza
                                        rowRange_1.format.rowHeight = 30;
                                        // Kolor tła #F7F7F7
                                        rowRange_1.format.fill.color = "#F7F7F7";
                                        // Kolor czcionki #000000
                                        rowRange_1.format.font.color = "#000000";
                                        // Rozmiar czcionki 12
                                        rowRange_1.format.font.size = 12;
                                        // Wyrównanie tekstu do lewej
                                        rowRange_1.format.horizontalAlignment = "Left";
                                        // Wyrównanie pionowe do środka
                                        rowRange_1.format.verticalAlignment = "Center";
                                        // Dodanie border dół i prawo w kolorze #E9E9E9
                                        rowRange_1.format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                        rowRange_1.format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                        // Dodanie prawego obramowania dla każdej komórki w wierszu
                                        var columns = ["A", "B", "C", "D", "E", "F", "G"];
                                        columns.forEach(function (col) {
                                            var cellRange = sheet.getRange("".concat(col).concat(rowIndex));
                                            cellRange.format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                            cellRange.format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                        });
                                    };
                                    for (i = 0; i < dataRowsCount; i++) {
                                        _loop_1(i);
                                    }
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    //Kolumna A dla wartości matrix jest wyrównana do środka i wartości zapisane jako tekst
                                    sheet.getRange("A10:A" + rowRange).format.horizontalAlignment = "Center";
                                    textFormatColumns = ["A"];
                                    textFormatColumns.forEach(function (column) {
                                        var columnRange = sheet.getRange("".concat(column, "10:").concat(column) + rowRange);
                                        // Stwórz tablicę formatów dla wszystkich komórek w kolumnie
                                        var formatArray = Array(dataMatrix.length).fill(["@"]);
                                        columnRange.numberFormat = formatArray;
                                    });
                                    // Kolumna B wartości Matrix jest wyrównana do lewej i ma zawijanie tekstu
                                    sheet.getRange("B10:B" + rowRange).format.horizontalAlignment = "Left";
                                    sheet.getRange("B10:B" + rowRange).format.wrapText = true;
                                    // Kolumna C  wartości Matrix jest wyrównana do środka i ma zawijanie tekstu
                                    sheet.getRange("C10:C" + rowRange).format.horizontalAlignment = "Center";
                                    sheet.getRange("C10:C" + rowRange).format.wrapText = true;
                                    // Kolumna D do G wartości Matrix jest wyrównana do środka i jest formatem liczbowym do 4 miejsca po przecinku
                                    sheet.getRange("D10:G" + rowRange).format.horizontalAlignment = "Center";
                                    sheet.getRange("D10:G" + rowRange).numberFormat = [["0.0000"]]; // Format liczbowy do 4 miejsca po przecinku
                                    // Dodanie filtrowania do nagłówków dla całego dodanego zakresu Matrix
                                    sheet.autoFilter.apply(sheet.getRange("A9:G" + rowRange));
                                    if (!EupType.isTrial) return [3 /*break*/, 3];
                                    trialRow = rowRange + 2;
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A".concat(trialRow, ":G").concat(trialRow), EupType.isTrial)];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3:
                                    copyrightRow = rowRange + 3;
                                    return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A".concat(copyrightRow, ":G").concat(copyrightRow))];
                                case 4:
                                    _a.sent();
                                    //Aktywowana komórka A1
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=keo_annualy.js.map